<template>
  <!-- FIXME: Regular slider and pricle slider track-btn moves together if you want change one slider value -->
  <div class="slider" v-tax-toggle="toggleTax">
    <h6 class="slider__title">{{ name }}</h6>
    <KaaliSlider
      v-if="type === 'kaali'"
      :min="maybeAddTax(min)"
      :max="maybeAddTax(max)"
      v-on:min-changed="updateMin"
      v-on:max-changed="updateMax"
    />
    <p class="slider__selected">
      {{translations.price}}: {{ formatNumber(displayedMin) }} - {{ formatNumber(displayedMax) }}
    </p>
  </div>
</template>

<style lang="scss" scoped>
.slider {
  &__title {
    margin-bottom: 2rem;
  }

  &__selected {
    margin-top: 2rem;
  }
}
</style>

<script>
import KaaliSlider from "@/components/general-ui/sliders/Kaali.vue";

export default {
  name: "PriceSlider",
  components: {
    KaaliSlider
  },
  props: {
    name: String,
    min: Number,
    max: Number
  },
  data() {
    return {
      type: ws_vue_store.config.slider,
      includingTax: ws_vue_store.including_tax === "1",
      fixedLength: ws_vue_store.fixed_length,
      sliderMin: 0,
      sliderMax: 0,
      translations: {
        price: ws_vue_store.translations.price,
      },
    };
  },
  computed: {
    displayedMin() {
      if (this.sliderMin > this.min) {
        return this.sliderMin;
      }
      return this.min;
    },
    displayedMax() {
      if (this.sliderMax < this.max && this.sliderMax != 0) {
        return this.sliderMax;
      }
      return this.max;
    }
  },
  methods: {
    formatNumber(value) {
      return `${this.maybeAddTax(value)
        .toFixed(this.fixedLength)
        .toString()
        .replace(".", ",")} €`;
    },
    updateMin(value) {
      this.sliderMin = value;
      this.$emit("price-min-changed", this.maybeRemoveTax(value));
    },
    updateMax(value) {
      this.sliderMax = value;
      this.$emit("price-max-changed", this.maybeRemoveTax(value));
    },
    maybeAddTax(value) {
      if (Number.isNaN(value) || value === "") return value;
      if (this.includingTax) {
        return parseFloat(value) * 1.2;
      }
      return value;
    },
    maybeRemoveTax(value) {
      if (Number.isNaN(value) || value === "") return value;
      if (this.includingTax) {
        return parseFloat(value) / 1.2;
      }
      return value;
    },
    toggleTax() {
      this.includingTax = !this.includingTax;
    }
  },
  directives: {
    "tax-toggle": {
      bind(el, binding) {
        window.wsTaxesToggledDirectiveEvent = event => binding.value(event);
        document.addEventListener("taxes-toggled", window.wsTaxesToggledDirectiveEvent);
      },
      unbind() {
        document.removeEventListener("taxes-toggled", window.wsTaxesToggledDirectiveEvent);
      }
    }
  }
};
</script>
